import React from 'react';
import { Checkbox } from '../../ui/Checkbox';
import { NON_INPUT_FIELD_TYPES, type FieldType } from '../../../types/forms';

export interface FieldRequiredToggleProps {
  fieldType: FieldType;
  checked: boolean;
  onChange: (required: boolean) => void;
}

/**
 * Controlled toggle de `required`. Retorna null silenciosamente para
 * non-input field types (heading/paragraph/welcome_screen/etc), que não
 * fazem sentido marcar como obrigatório.
 */
export const FieldRequiredToggle: React.FC<FieldRequiredToggleProps> = ({
  fieldType,
  checked,
  onChange,
}) => {
  if (NON_INPUT_FIELD_TYPES.includes(fieldType)) return null;
  return (
    <Checkbox
      label="Campo obrigatório"
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
    />
  );
};
